<app-page-meta pageTitle="finzy - Investor Dashboard"></app-page-meta>
<app-header></app-header>

<div class="container-fluid">
  <div class="row">
    <app-investormenu></app-investormenu>

    <div class="col-xs-12 col-md-10 col-lg-11 main-content">
      <div *ngIf="lenderPortfolios === undefined" class="spinner-section">
        <mat-spinner [diameter]="35" class="col-xs-offset-6"></mat-spinner>
    </div>
      <div class="row finzy-row2" *ngIf="lenderPortfolios?.length === 0">
          <p class="finzy-txt-loan">Welcome to Finzy</p>
          <ng-container *ngIf="!isFINXLender">
          <p class="finzy-txt-ps">Let's begin with creating your first portfolio</p>
          <p class="finzy-txt-ps-pro">Our <a class="finzy-pro-know-no-underline font-bold" target="_blank"
                                            [routerLink]="['/faq']">
            finzyPRO+</a> algorithm automatically picks the best suited loans for you
            <a class="finzy-pro-know-underline" target="_blank" [routerLink]="['/faq']">(know more)</a>
          </p>
          <p *ngIf="!isMinimumWalletBalanceExistForInitialPortfolio" class="finzy-txt-ps-pro finzy-red">
            A minimum of Rs 50,000 is required to create your first portfolio. Please update your wallet.
          </p>
          <p class="finzy-txt-ps-pro">
            <strong>Loans are getting filled fast on finzy! See the loans funded by other investors <a [routerLink]="['/recently-filled-loans']">here.</a></strong>
          </p>
          <div class="row finzy-row3">
            <div class="col-sm-offset-1 col-sm-10" *ngIf="(!insufficientWallet)">
              <p class="finzy-p7">INVESTMENT AMOUNT</p>
              <form name="form" (keydown.enter)="$event.preventDefault()"
                    (ngSubmit)="investmentAmountForm.form.valid && onCreateAutoPortfolioClicked(investmentAmt)"
                    #investmentAmountForm="ngForm"
                    novalidate>
                <div class="row">
                  <div class="col-sm-offset-3 col-sm-6">
                    <mat-form-field>
                      <span matPrefix style="font-size: 122%">₹&nbsp;</span>
                      <input matInput class="investment-amount-input" placeholder="" [(ngModel)]=investmentAmt maxlength="10"
                            #investmentAmount="ngModel" name="investmentAmt" type="text"
                            [disabled]="!isMinimumWalletBalanceExistForInitialPortfolio" required>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row finzy-create-portfolio-err">
                  <span class="finzy-red" *ngIf="investmentAmt>maximumInvestmentLimit">Amount breaches the principal outstanding limit</span>
                </div>
                <div class="row lender-investment-div" *ngIf="getInvestmentAmountInfoMessage()">
                  <p class="lender-investment-text">{{getInvestmentAmountInfoMessage()}}</p>
                </div>
                <div class="row lender-consent">
                  <mat-checkbox style="display: inline;" [(ngModel)]="lender10LakhLimitDeclarationCheck"
                                name="lenderInvestmentLimitConfirmed"
                                (change)="onLenderInvestmentLimitConfirmed()">
                  </mat-checkbox>
                  <p class="lender-consent-text" style="display: inline;">
                    I, hereby confirm that I have not invested more than ₹50,00,000 across all the P2P platforms in India, including
                    www.finzy.com and hereby undertake to inform finzy if my aggregate exposure from investing, across all the P2P platforms
                    in India, at any point of time is equivalent to ₹50,00,000, and understand and agree that finzy shall be entitled to take
                    any
                    and all actions as it may deem fit.
                    <br/>
                    <br/>

                    I, hereby also agree that as and when my investment across all the P2P platforms in India including www.finzy.com exceed
                    ₹10,00,000, I will provide finzy a net-worth certificate from a practicing Chartered Accountant in the
                    <a [href]="getFileUrlByName('investorNetworthCertificate')">attached
                      format</a> certifying that I have net-worth of more than ₹50,00,000.
                    <br/>
                    <br/>

                    I, hereby also confirm that I have understood all the risks associated with the lending transactions and finzy does not
                    assure return of principal/payment of interest and there exists a likelihood of loss of the entire principal in case of
                    default by a borrower.
                  </p>
                </div>
                <div class="row">
                  <div class="col-sm-offset-3 col-sm-6">
                    <div *ngIf="loader.spin === true" class="loader wallet-submit-loader">
                      <mat-spinner [diameter]="35"></mat-spinner>
                    </div>
                    <button *ngIf="loader.spin === false" mat-flat-button class="no-text-transform primary" [disabled]="!isFormValid(investmentAmountForm.valid)"
                            type="submit">
                      CREATE finzyPRO+ PORTFOLIO
                    </button>
                  </div>
                </div>
              </form>

              <div class="row finzy-create-portfolio-err"
                  *ngIf="walletAmount >= minimumInvestmentLimit">Wallet balance is
                <app-indian-currency-formatter [amount]="walletAmount"></app-indian-currency-formatter>
              </div>

              <div class="row finzy-create-portfolio-err" *ngIf="walletAmount<investmentAmt"
                  style="color:red;float: left;margin-left: auto;margin-right: auto;">Insufficient funds in
                the wallet.
              </div>

              <div class="row finzy-create-portfolio-err">Investment amount should be in multiples of
                <app-indian-currency-formatter [amount]="1000"></app-indian-currency-formatter>
                and minimum
                investment amount in a portfolio is
                <app-indian-currency-formatter [amount]="5000"></app-indian-currency-formatter>
                .
              </div>

              <div class="row finzy-create-portfolio-err" style="color:red;float: left;"
                  *ngIf="manualInvestDashboardError">

                {{manualInvestDashboardErrorMsg}}

              </div>

            </div>
            <div class="col-sm-offset-3 col-sm-6" *ngIf="insufficientWallet">
              <div class="row finzy-create-portfolio-err"
                  style="color:#4a4a4a;float: left;margin-left: auto;margin-right: auto;">Looks like there
                are insufficient funds in your wallet. A minimum of <span
                  style="color: red">INR 50,000</span>
                is required in your wallet to keep investing. Please transfer the funds to continue
                investing.
                <br><br>
                Here are the <a style="color: #0d3ab3;text-decoration: none;cursor: pointer;"
                                (click)="closeModal()">details</a>
                of how you can tranfer your funds.
                <br><br>
                If you need assistance you can find help here <a target="_blank"
                                                                style="color: #0d3ab3;text-decoration: none;"
                                                                [routerLink]="['/faq']">FAQs.</a> You could
                even call us
                on 9341 300 300. We are always happy to help!
              </div>
            </div>
            <div class="col-sm-4">

            </div>
          </div>
          <div *ngIf="!insufficientWallet">
            <p class="finzy-txt-ps3">Although our finzyPRO+ is crafted to give you the best returns,</p>
            <p class="finzy-txt-ps4">you could also choose to use our <span class="finzy-col bold"
                                                                            (click)="onCreateManualPortfolioClicked(investmentAmt)">manual option</span>
            </p>
          </div>
      </ng-container>
      </div>
      <div class="row finzy-row7" *ngIf="lenderPortfolios?.length > 0">
        <div class="row finzy-row" style="margin-left: 10px; margin-right: 10px;">
          <div class="row finzy-row7">
            <p class="finzy-txt-p">Hi {{name}}, here's how your investments are doing</p>
            <p class="text-color-finzy-blue font-bold big-text text-center">ROI {{ metrics && metrics.roi}}%</p>
            <p class="text-center" style="color: #4a4a4ad6;">
              IRR post 2% finzy fees and 18% GST on the fees
              <app-tooltip placement="bottom">
                <i class="info-icon material-icons" trigger>info_outline</i>
                <div content style="max-width: 300px;">Internal Rate of Return (IRR) is a measure of an investment’s
                  rate of return. This
                  takes into account the timing and quantum of cash inflow and outflow such as to make the Net Present
                  Value (NPV) of cash
                  flow 0.
                </div>
              </app-tooltip>
            </p>
          </div>
          <div class="row finzy-row7" *ngIf="showPieChart()">
            <div class="col-md-4 col-md-offset-4">
              <app-doughnut name="overallInvestmentPerformance" [dataSet]="overallChartData"></app-doughnut>
            </div>
          </div>
        </div>
        <div class="row finzy-row7 mt-2">
            <app-investment-metrics
              (createNewPortfolioBtn)="openDialog()"
              [isCreateNewPortfolioDisabled]="preferences && isPortfolioCreationEnabled()"
              [walletAmount]="walletAmount"
              [metrics]="metrics"
            >
          </app-investment-metrics>
        </div>
      </div>
  </div>
</div>
</div>

<app-footer></app-footer>
